module.exports = __webpack_public_path__ + "static/media/features1.d681d29d.jpg";